import Vue from 'vue'
import Vuex from 'vuex'

import config from './config'
import date from './date'
import address from './address'
import item from './item'
import variation from './variation'
import person from './person'
import event from './event'
import places from './places'
import payment from './payment'
import user from './user'
import comment from './comment.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {
        onDataLoaded() {
            console.log('[vuex] Данные загружены');
            // Выставить значения по-умолчанию из config.json
            this.dispatch('config/applyOptionsPreset')
                .catch(error => console.log('[vuex] onDataLoaded()', error))
                // Выставить сохраненные значения из LocalStorage
                .finally(() => {
                    this.dispatch('config/loadStateFromLocalStorage');
                });
        },
        onError(context, error) {
            console.error(`[vuex] fetchData()\n${error}`);
            /* TODO: Обработать ошибку когда данные не загрузились */
        },
        async fetchData() {
            // Сначала запрос конфигурации виджета
            await this.dispatch('config/fetchConfig', {/*request options*/});
            // Затем запрос остальных данных (на основе ответа конфигурации)
            // todo: Не запрашивать все здесь!
            //  Запросы нужно отправлять при открытии соотв. страницы
            //  - c исходящими из конфига данными (если какие-то необходимы)
            //  - и основываясь на предыдущих выбранных данных
            //  Запихивать эти данные можно в options и в файле api.js разруливать запрос
            await Promise.all([
                this.dispatch('address/fetchAddresses', {/*request options*/}),
                this.dispatch('item/fetchItems', {/*request options*/}),
                this.dispatch('variation/fetchVariations', {/*request options*/}),
                this.dispatch('person/fetchPersons', {/*request options*/}),
            ])
                .catch(console.error)
                .then(() => this.dispatch('onDataLoaded'));
        }
    },
    modules: {
        config,
        date,
        address,
        item,
        variation,
        person,
        event,
        places,
        payment,
        user,
        comment,
    }
})
